<template>
    <div class="page-content">
        <div class="content-fluid">
            <h4>Cambiar Contraseña</h4>

            <div class="row">
                <div class="col-12 col-sm-10 m-sm-auto">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-text">
                                <app-form-password-input
                                    label="Escribe la contraseña actual"
                                    id="oldPassword"
                                    v-model="oldPassword"
                                    :required="true"
                                    :hasError="$v.oldPassword.$error"
                                    errorMessage="Debe escribir la contraseña actual"
                                >
                                </app-form-password-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-12 col-sm-10 m-sm-auto">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-text">
                                <app-form-password-input
                                    label="Escribe la nueva contraseña"
                                    id="password1"
                                    v-model="newPassword1"
                                    :required="true"
                                    :hasError="$v.newPassword1.$error"
                                    errorMessage="Debe escribir la nueva contraseña mínimo 6 caracteres"
                                >
                                </app-form-password-input>
                                <app-form-password-input
                                    label="Confirma la nueva contraseña"
                                    id="password2"
                                    v-model="newPassword2"
                                    :required="true"
                                    :hasError="$v.newPassword2.$error"
                                    errorMessage="La contraseña debe coincidir"
                                >
                                </app-form-password-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-10 m-sm-auto text-right">
                    <hr />
                    <button class="btn btn-confirm" @click="changePassword()">
                        <i class="fa fa-retweet" aria-hidden="true"></i> Cambiar
                        contraseña
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import userRepository from "../../../repositories/users.repository.js";
import FormPasswordInput from "../../UI/Controls/Forms/FormPasswordInput.vue";
import { required, sameAs, minLength } from "vuelidate/lib/validators";
export default {
    components: {
        appFormPasswordInput: FormPasswordInput
    },
    data() {
        return {
            oldPassword: "",
            newPassword1: "",
            newPassword2: ""
        };
    },
    validations: {
        oldPassword: { required },
        newPassword1: { required, minLength: minLength(6) },
        newPassword2: { sameAs: sameAs("newPassword1") }
    },
    methods: {
        changePassword() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }
            const payload = {
                userId: this.user.id,
                password1: this.newPassword1,
                password2: this.newPassword2,
                oldPassword: this.oldPassword
            };

            const ur = Object.assign({}, userRepository);
            ur.changePassword(payload)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.cleanFields();
                        this.$v.$reset();

                        this.$router.push({
                            name: "loginPage"
                        });
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => toastr.error("Error al cambiar la contraseña"));
        },
        cleanFields() {
            this.oldPassword = "";
            this.newPassword1 = "";
            this.newPassword2 = "";
        }
    }
};
</script>

